import { useState, useEffect } from "react";
import { collection, query, getDocs, orderBy, startAt, endAt } from "firebase/firestore";
import { db, auth } from "../../firebaseConfig";
import NavMenu from "./MaterialUI/NavMenu";
import AccountMenu from "./MaterialUI/AccountMenu";
import "./NavBar.css";
import "../components/ChatForm/SearchBar.css";
import PropTypes from "prop-types";

function NavBarHome({ title }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const unsubscribe =
      auth && typeof auth.onAuthStateChanged === "function"
        ? auth.onAuthStateChanged((user) => {
            setCurrentUser(user);
          })
        : undefined;

    return () => {
      if (typeof unsubscribe === "function") {
        try {
          unsubscribe();
        } catch (e) {
          if (import.meta.process.env.NODE_ENV !== "production") {
            console.warn("NavBarHome unsubscribe failed in test env", e);
          }
        }
      }
    };
  }, []);

  useEffect(() => {
    const fetchViews = async () => {
      if (!currentUser) return;
      if (searchTerm === "") {
        setSearchResults([]);
        return;
      }

      const viewsCollectionRef = query(collection(db, "views"), orderBy("title"), startAt(searchTerm), endAt(searchTerm + "\uf8ff"));

      try {
        const viewsSnapshot = await getDocs(viewsCollectionRef);
        const viewsList = viewsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setSearchResults(viewsList);
      } catch (error) {
        console.error("Error fetching views:", error);
      }
    };

    fetchViews();
  }, [searchTerm, currentUser]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <nav className="navbar-static">
      <div className="navbar-left">
        <NavMenu />
        <div className="pageTitle">
          <h5>{title}</h5>
        </div>
      </div>
      <div className="form-home">
        <textarea className="textarea" type="text" placeholder="Search views..." value={searchTerm} onChange={handleSearchChange} />

        <div className="search-results">
          {searchResults.map((view) => (
            <a key={view.id} href={`/views/${view.id}`} className="search-result-item">
              {view.title}
            </a>
          ))}
        </div>
      </div>

      <div className="navbar-right">
        <AccountMenu />
      </div>
    </nav>
  );
}

NavBarHome.propTypes = {
  title: PropTypes.string.isRequired,
};

export default NavBarHome;
